const VALIDATION_ERRORS: { [key: string]: string } = {
  required: 'Field Required',
  validateMobileNumber: 'Invalid mobile number',
  generic: 'Something went wrong!',
  validatePinCode: 'Enter a valid Pin Code',
  invalidTechnicianCode: 'Invalid technician code',
  invalidCoupon: 'Coupon code is invalid',
  validateEmail: 'Invalid email address',
  minimumLengthValidation: 'Minimum 3 characters required',
  minLength: 'Minimum length not met',
  maxLength: 'Maximum length not met',
  pattern: 'Invalid input',
};

export default VALIDATION_ERRORS;
